import type {AxiosRequestConfig} from 'axios';
import {Status, User} from '../users/interface';

export class GetSellersBuilder {
  private readonly providerRequest: AxiosRequestConfig = {
    method: 'GET',
    url: '/sellers/',
    params: {},
  };

  params(params: object) {
    this.providerRequest.params = params;
    return this;
  }

  build() {
    return this.providerRequest;
  }
}

export class GetSellersCountBuilder {
  private readonly providerRequest: AxiosRequestConfig = {
    method: 'GET',
    url: '/sellers/count',
    params: {},
  };

  params(params: object) {
    this.providerRequest.params = params;
    return this;
  }

  build() {
    return this.providerRequest;
  }
}

export class UpdateSellerStatusRequestBuilder {
  private readonly request: AxiosRequestConfig = {
    method: 'PUT',
    url: '',
    data: {},
  };

  id(id: number) {
    this.request.url = `/sellers/${id}/status`;
    return this;
  }

  data(body: Status) {
    this.request.data = `"${body}"`;
    return this;
  }

  build() {
    return this.request;
  }
}

export class CreateSellerRequestBuilder {
  private readonly request: AxiosRequestConfig = {
    method: 'POST',
    url: '/sellers/',
    data: {},
  };

  data(data: User) {
    this.request.data = data;
    return this;
  }

  build() {
    return this.request;
  }
}
